export default __webpack_public_path__ + "static/media/2019_exteriorFinalizat1.844f9877.jpeg";